import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { fetchAPI, fetchSEO } from '../../lib/blog/api'
import ResourceCard from '../../components/blog/ResourceCard'
import Seo from '../../components/blog/Seo'
import SubscribeViaEmailModal from '../../components/SubscribeViaEmailModal'
import CtaButton from '../../components/landing/elements/CtaButton'

const Articles = ({ articles }) => {
  const getMdWidth = (article) => {
    if (article.attributes.tileSize === 'width 3') {
      return 12
    }
    if (article.attributes.tileSize === 'width 2') {
      return 12
    }
    return 6
  }
  const getLgWidth = (article) => {
    if (article.attributes.tileSize === 'width 3') {
      return 12
    }
    if (article.attributes.tileSize === 'width 2') {
      return 8
    }
    return 4
  }

  return (
    <Row className='mb-2'>
      {articles.map((article, index) => {
        return (
          <Col
            xs={12}
            md={getMdWidth(article)}
            lg={getLgWidth(article)}
            key={`article_${article.attributes.slug}_${index}`}
            className='mb-5'
          >
            <ResourceCard
              article={article}
              path={'resources'}
            />
          </Col>
        )
      })}
    </Row>
  )
}

const EmptyState = ({ error }) => {
  return (
    <Row className='py-2 py-lg-5'>
      <Col
        xs={12}
        className='text-center'
      >
        <div className='fs-3'>
          {error
            ? 'Under maintenance 🛠️'
            : 'No articles added yet 🫥'
          }
        </div>

        <div className={'my-5 bg-light br-3'}>
          <Row className='d-flex justify-content-center '>
            <Col xs={12} md={11} xl={9}>
              <div className='p-3 p-md-4 p-lg-5'>
                <div className='fs-3 mb-4'>
                  But we have something even better —
                </div>
                <div className='d-flex justify-content-center'>
                  <div style={{ maxWidth: 400 }}>
                    <CtaButton />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  )
}

const Blog = ({ articles, error, seo }) => {
  return (
    <>
      <Seo seo={seo} />

      <Row className='mb-5 mt-3'>
        <Col xs={12}>
          <h1 className='text-center fw-semibold'>
            Resources
          </h1>
        </Col>
      </Row>

      {articles.length
        ? (
        <Articles articles={articles} />
          )
        : (
        <EmptyState error={error} />
          )}

      <SubscribeViaEmailModal />
    </>
  )
}

export async function getStaticProps () {
  let articles = []
  let backendError = false

  const seo = await fetchSEO('resources')
  const articlesRes = await fetchAPI('/articles', { populate: ['image'] })
  if (articlesRes) {
    articles = articlesRes.data
  } else {
    backendError = true
  }

  return {
    props: {
      articles,
      seo,
      error: backendError
    },
    revalidate: 60 * 60 * 24
  }
}

export default Blog
